<template>
  <atoms-card
    class="text-center py-6"
    :class="[
      {
        'bg-blue-900 text-white px-5 pb-6' : theme === 'dark',
        'text-dark bg-white': theme === 'default'
      }
    ]"
    :rounded="theme === 'dark' ? 'xl' : 'lg'"
    :shadow="theme === 'default' ? 'lg' : 'none'"
    size="md"
    theme="plain"
  >
    <!-- eslint-disable vue/no-v-html -->
    <p
      class="mt-0 mb-4"
      :class="[
        {
          'text-3xl text-yellow-600 font-normal' : theme === 'dark',
          'text-xl font-bold': theme === 'default'
        },
        titleClass
      ]"
      v-html="title"
    >
    </p>

    <hr
      class="border-0 border-b border-gray-350"
      :class="{
        'hidden' : theme === 'dark'
      }"
    />

    <p
      class="mt-4"
      :class="{
        'text-gray-125 text-sm mb-8': theme === 'default',
        'lg:text-lg font-bold mt-1 mb-4' : theme === 'dark'
      }"
    >
      {{ subTitle }}
    </p>

    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-y-2 mt-4"
      :class="[
        {
          'gap-x-2': theme == 'default',
          'gap-x-4': theme == 'dark'
        },
        optionsClass
      ]"
    >
      <div
        v-for="(option, index) in options"
        :id="`cta-lifecover-${strToKebabCase(option?.label || option).toLowerCase()}`"
        :key="index"
        class="col-lg-3 col-md-3 col-sm-3"
      >
        <atoms-cta
          :id="`cta-sidebar-${strToKebabCase(option?.label || option).toLowerCase()}`"
          :to="option?.pageUrl || formUrl"
          :class="[
            {
              'py-2': theme === 'dark'
            },
            ctaClass
          ]"
          :theme="theme === 'dark' ? 'tertiary2' : 'primaryWhite'"
          target="_self"
          align="center"
          size="medium"
          rounded="standard"
          class="flex justify-center items-center px-0"
        >
          <NuxtImg
            v-if="option.icon"
            :src="option.icon"
            :alt="option.label"
            :width="option.iconDimensions && option.iconDimensions.width"
            :height="option.iconDimensions && option.iconDimensions.height"
          />

          {{ (option && option.label) || option }}
        </atoms-cta>
      </div>
    </div>
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'MoleculesLifeCover'
})

const props = defineProps({
  title: {
    type: String,
    default: 'How Much Life Cover Do You Need?'
  },

  subTitle: {
    type: String,
    default: 'We’ll show you our best quotes.'
  },

  componentVertical: {
    type: String,
    default: 'Life Insurance'
  },

  customComponent: {
    type: Object,
    default: () => ({})
  },

  theme: {
    type: String,
    default: 'default'
  },

  options: {
    type: Array,
    default: () => ['$100K - $200K', '$200K - $300K', '$300K - $400K', '$400K - 500K', '$500K - $600K', '$600K - $700K', '$700K - $800K', '$800K - $900K', '$900K - $1M', '$1M - $1.1M', '$1.1M - $1.2M', '$1.2M - $1.3M', '$1.3M - $1.4M', '$1.4M - $1.5M', '$1.5M - $1.6M', '$1.6M - $1.7M', '$1.7M - $1.8M', '$1.8M - $1.9M', '$1.9M - $2M', '$2M+']
  },

  optionsClass: {
    type: String,
    default: ''
  },

  titleClass: {
    type: String,
    default: ''
  },

  isIncomeProtection: {
    type: Boolean,
    default: false
  },

  ctaClass: {
    type: String,
    default: ''
  }
})

const formUrl = computed(() => {
  const verticalUrls = {
    [VERTICAL.HEALTH_INSURANCE]: '/health-insurance/quote/form/step1/',
    [VERTICAL.LIFE_INSURANCE]: '/life-insurance/quote/form/step1/',
    [VERTICAL.ENERGY]: '/energy/quote/form/step1/',
    [VERTICAL.HOME_LOANS]: '/home-loans/quote/form/step1/',
    [VERTICAL.PERSONAL_LOANS]: '/personal-loans/quote/form/step1/',
    [VERTICAL.CAR_LOANS]: '/personal-loans/quote/form/step1/'
  }

  const customUrl = props.customComponent.to
  const vertical = props.componentVertical

  return customUrl || verticalUrls[vertical] || '/'
})
</script>
